// @flow
import type { Transform } from 'styled-system';
import { isReactNative } from '@rover/utilities/userAgent';

export const createTransformWithDefault = (defaultValue: string | number | void): Transform => (
  propValue,
  scale
) => {
  if (!scale) {
    return defaultValue;
  }
  return scale[propValue] || defaultValue;
};

export const reactNativeSafeTransform: Transform = value => {
  // for RxN we need to remove the 'px'/etc units...
  const rxnSafeValue = isReactNative() ? parseInt(value, 10) : value;
  // but unitless values need to be turned back into string form else React will cleverly put the 'px' back on numerics.
  return rxnSafeValue.toString();
};



// WEBPACK FOOTER //
// ../react-lib/src/styles/styled-system/transforms.js